import ClearIcon from '@mui/icons-material/Clear';
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Collapse,
  Dialog,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  LinearProgress,
  Radio,
  RadioGroup,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { SetStateAction, useContext, useEffect, useState } from 'react';

import axios, { AxiosResponse } from 'axios';
import { API_ENDPOINT } from '../../../../configurations/global.config';
import { AuthContext } from '../../../../contexts/user-context/user-context';
import { emptyCustomer } from '../../../../data/customers';
import { emptyMerchant } from '../../../../data/merchants';
import { useBranchRecommendation } from '../../../../hooks/useBranchRecommendation';

import LocalShippingIcon from '@mui/icons-material/LocalShipping';

import QrCode2Icon from '@mui/icons-material/QrCode2';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import {
  RegionType,
  emptyRegion,
  getGovernorateForDistrict,
  regions,
} from '../../../../data/regions';
import { CustomerType } from '../../../../interfaces/common/customer';
import { BranchType } from '../../../../interfaces/delivery-company/branches';
import {
  CompactMerchantType,
  MerchantType,
} from '../../../../interfaces/delivery-company/merchants';
import { CriticalOrderSurcharge, OrderType } from '../../../../interfaces/delivery-company/orders';
import AutocompleteWithThrottle from '../../../common/autocomplete-with-throttle/autocomplete-with-throttle';
import {
  assignBranchProvider,
  assignCustomerProvider,
  assignLocationProvider,
  assignMerchantProvider,
  assignPickupLocationProvider,
} from '../../../common/create-callbacks-utils/create-callbacks-utils';
import TextFieldWithScan from '../../../common/textfield-with-scan/textfield-with-scan';
import CreateBranchForm from '../../branches/create-branch-form/create-branch-form';
import CreateMerchantForm from '../../merchants/merchant-forms/create-or-edit-merchant';
import { emptyOrder } from './create-order-form.utils';
import {
  LabelValue,
  LabelValueWithKey,
} from '../../../../interfaces/delivery-company/labels';
import AddressInputWithAutocomplete from '../../../common/adress-input-with-autocomplete/address-input-with-autocomplete';
import { ErrorsFlattenner } from '../../../common/errors-flattenner/errors-flattenner';
import Decimal from 'decimal.js';
import MoneyInput from '../../../common/money-input/money-input';
import { add, CURRENCY, displayMoney, minus, Money } from '../../../../utils/money';
import { get_cod, get_price } from '../../../../utils/cod';
import WeightInput from '../../../common/weight-input/weight-input';
import DimensionsInput from '../../../common/dimensions-input/dimensions-input';
import { DeliveryState, Workflow } from '../../../../enums/orders';
import InputWithLegend from '../../../common/input-with-legend/input-with-legend';
import { ShopLocationType } from '../../../../interfaces/delivery-company/pickups';
import CreatePickupLocationForm from '../../pickup-location-form/pickup-location-form';
import InfoIcon from '@mui/icons-material/Info';
import { ILocation } from '../../../../interfaces/common/location';
import CreateLocationForm from '../../location-form/location-form';
import { isMobile, isTablet } from 'react-device-detect';
import CustomDialog from '../../../common/custom-dialog/custom-dialog';
import { showCustomerAutocompleteOption } from '../../../../utils/customers';
import CreateCustomerForm from '../../../common/create-customer-form/create-customer-form';
import { useSnackBar } from '../../../../contexts/snackbar';
import { Edit, ExpandLess, ExpandMore, Info, TurnedInNot, Work, YouTube, LocationOn as LocationOnIcon, Warning as WarningIcon } from '@mui/icons-material';
import LabelsInput from '../../../common/labels-input/labels-input';
import GenericTable from '../../../common/generic-table/generic-table';
import { displayLocation } from '../../../../utils/locations';
import IncompleteAddressError from '../../../common/incomplete-address-error/incomplete-address-error';
import { IDeliveryChargeRule } from '../../merchants/delivery-charge-rules/interfaces';
import { displayDeliveryRule } from '../../merchants/delivery-charge-rules/utils';
import { deliveryChargeRuleApplies } from '../../../../utils/delivery_charge_rules';
import DeliveryChargeOverrides from '../../merchants/delivery-charge-rules/delivery-charge-overrides';
import DeliveryChargeOverridesDialog from '../../merchants/merchant-forms/delivery-charge-overrides-dialog';
import { GiCrackedGlass } from 'react-icons/gi';
import BrokenGlassIcon from '../../../common/icons/broken-glass';
import { IconWithText } from '../../../common/styles/components';
import { OrgSettingsContext } from '../../../../contexts/org-settings-context';
import { useVideoTutorial } from '../../../../contexts/video-tutorial-context/video-tutorial-context';
import TextFieldWithArabicKeyboard from '../../../common/text-field-with-arabic-keyboard';
import CriticalOrderBalanceDisplay from '../../../common/critical-order-balance-display/critical-order-balance-display';
import { CriticalOrderBalance } from '../../../../interfaces/delivery-company/orders';
import { calculateBaseDeliveryFee, calculateExtraDeliveryCharges, splitExtraCharges, updateDeliveryFee } from '../../../../utils/order';
import { useCriticalOrders } from '../../../../hooks/use-critical-orders';
import { useApiConfigWithBranch } from '../../../../hooks/use-api-config-with-branch';
import PackagesEditor from '../../../common/packages-editor/packages-editor';

interface CreateOrderFormProps {
  defaultOrder?: OrderType;
  onSuccess?: (order: OrderType) => void;
}

function CreateOrderForm({ defaultOrder, onSuccess }: CreateOrderFormProps) {
  console.log('defaultorder = ', defaultOrder);
  const {  config } = useApiConfigWithBranch()

  const { color } = useContext(OrgSettingsContext);

  const { showVideoTutorial } = useVideoTutorial();
  const {fetchBalance, loadingBalance, balance} = useCriticalOrders();


  const [orderData, setOrderData] = useState<OrderType | undefined>(() => {
    if (defaultOrder != undefined) return defaultOrder;
    return { ...emptyOrder, delivery_state: DeliveryState.AT_WAREHOUSE };
  });
  const [extraChargesExpanded, setExtraChargesExpanded] = useState(false);
  const [isUpdatingDeliveryFees, setIsUpdatingDeliveryFees] = useState(false);

  const setSelectedLabels = (selectedLabels: LabelValueWithKey[]) => {
    if (orderData) {
      const baseCharge = calculateBaseDeliveryFee(orderData);
      setOrderData(
        updateDeliveryFee({ ...orderData, labels: selectedLabels }, baseCharge)
      );
    }
  };

  const applyDeliveryFeeRules = (rules: IDeliveryChargeRule[]) => {
    if (orderData) {
      const baseCharge = calculateBaseDeliveryFee(orderData);

      const amount = rules
        .map((rule) => rule.delta_charge)
        .reduce((a, b) => a.add(b), Decimal(0));
      if (!amount.isZero()) {
        showMessage(`${amount.toString()}$ charge`, 'info');
      }

      setOrderData(
        updateDeliveryFee(
          { ...orderData, delivery_fee_rules: rules },
          baseCharge
        )
      );
    }
  };

  const clearDeliveryFeeRule = () => {
    if (orderData) {
      const baseCharge = calculateBaseDeliveryFee(orderData);
      setOrderData(
        updateDeliveryFee({ ...orderData, delivery_fee_rules: [] }, baseCharge)
      );
    }
  };

  const [workflow, setWorkflow] = useState<Workflow>(
    orderData ? orderData.workflow : Workflow.STANDARD
  );

  const { showMessage } = useSnackBar();

  console.log('order Data = ', orderData);
  const [creatingNewCustomerOpenFor, setCreatingNewCustomerOpenFor] =
    useState<CustomerType | null>(null);
  const [creatingNewMerchantOpen, setCreatingNewMerchantOpen] =
    useState<boolean>(false);
  const [creatingNewBranchOpen, setCreatingNewBranchOpen] =
    useState<boolean>(false);
  const [createPickupLocation, setCreatePickupLocation] = useState(false);
  const [createLocation, setCreateLocation] = useState(false);

  const [explainDeliveryRule, setExplainDeliveryRule] = useState(false)

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [loadingMessage, setLoadingMessage] = useState<string>('');
  const [response, setResponse] = useState<AxiosResponse>();
  const [message, setMessage] = useState<string>('');
  
  // Track if user manually overrode the recommendation
  const [userOverrodeRecommendation, setUserOverrodeRecommendation] = useState<boolean>(false);
  
  // Track if user confirmed the branch override
  const [confirmedBranchOverride, setConfirmedBranchOverride] = useState<boolean>(false);
  
  // Use branch recommendation hook
  const {
    recommendation: branchRecommendation,
    isLoading: isLoadingBranchRecommendation,
    allBranches,
  } = useBranchRecommendation({
    workflow: orderData?.workflow,
    customerLocationId: orderData?.customer_location?.id,
    merchantLocationId: orderData?.merchant_location?.id,
    enabled: defaultOrder === undefined, // Only fetch for new orders
  });

  const [cod, setCod] = useState<Money[]>(get_cod(orderData ?? emptyOrder));

  // Auto-select recommended branch when recommendation changes
  useEffect(() => {
    if (defaultOrder === undefined && !userOverrodeRecommendation) {
      if (branchRecommendation?.recommended_branch) {
        const recommendedId = branchRecommendation.recommended_branch.id;
        const currentId = orderData?.branch?.id;
        
        // Auto-update if: no branch selected, or current branch was a previous recommendation
        if (!currentId || currentId !== recommendedId) {
          setOrderData((prev) => ({
            ...prev!,
            branch: {
              id: recommendedId,
              name: branchRecommendation.recommended_branch!.name,
              letter: branchRecommendation.recommended_branch!.letter,
            } as BranchType,
          }));
        }
      } else if (branchRecommendation === null && orderData?.branch) {
        // Clear branch when recommendation is removed (e.g., location unselected)
        setOrderData((prev) => ({
          ...prev!,
          branch: null,
        }));
      }
    }
  }, [branchRecommendation, userOverrodeRecommendation, defaultOrder]);
  
  // Auto-select single branch when only one branch is available
  useEffect(() => {
    if (defaultOrder === undefined && allBranches.length === 1 && !orderData?.branch) {
      const singleBranch = allBranches[0];
      setOrderData((prev) => ({
        ...prev!,
        branch: {
          id: singleBranch.id,
          name: singleBranch.name,
          letter: singleBranch.letter,
        } as BranchType,
      }));
    }
  }, [allBranches, defaultOrder, orderData?.branch]);
  
  // Reset confirmation checkbox when branch changes
  useEffect(() => {
    setConfirmedBranchOverride(false);
  }, [orderData?.branch?.id]);

  const handleFetchCustomers = async (
    query: string
  ): Promise<CustomerType[]> => {
    if (orderData) {
      let merchant_pk = '';
      if (orderData.merchant != null) merchant_pk = orderData.merchant.id;

      let endpoint = `${API_ENDPOINT}/api/v1/customers/?page_size=10&name_or_phone=${encodeURIComponent(query)}`;
      if (merchant_pk != '') endpoint += `&merchant=${merchant_pk}`;

      console.log('endpoint = ', endpoint);

      try {
        const response = await axios.get<{
          count: number;
          results: CustomerType[];
        }>(endpoint, config);
        return response.data.results;
      } catch (error) {
        console.log(error);
      }
    }

    return [];
  };

  const handleFetchMerchants = async (
    query: string
  ): Promise<MerchantType[]> => {
    if (orderData) {
      if (orderData.customer && orderData.customer.id != '') {
        if (orderData.customer.merchant) {
          return [orderData.customer.merchant];
        }
        return [];
      }
      const endpoint = `${API_ENDPOINT}/api/v1/merchants/?page_size=10&name_or_phone=${encodeURIComponent(query)}`;
      try {
        const response = await axios.get<{
          count: number;
          results: MerchantType[];
        }>(endpoint, config);

        return response.data.results;
      } catch (error) {
        console.log(error);
      }
    }

    return [];
  };

  const handleFetchPickupLocations = async (query: string) => {
    if (orderData && orderData.merchant != null) {
      const endpoint = `${API_ENDPOINT}/api/v1/pickups/?page_size=10&merchant=${orderData.merchant.id}&name__contains=${encodeURIComponent(query)}`;

      try {
        const response = await axios.get<{
          count: number;
          results: ShopLocationType[];
        }>(endpoint, config);

        console.log(response);
        return response.data.results;
      } catch (error) {
        console.log(error);
      }
    }

    return [];
  };

  const handleFetchCustomerLocation = async (query: string) => {
    if (orderData && orderData.customer && orderData.customer.id != '') {
      const endpoint = `${API_ENDPOINT}/api/v1/locations/?page_size=100&customer=${orderData.customer.id}&name__contains=${encodeURIComponent(query)}`;

      try {
        const response = await axios.get<{
          count: number;
          results: ILocation[];
        }>(endpoint, config);

        return response.data.results;
      } catch (error) {
        console.log(error);
      }
    }

    return [];
  };

  // Initialise data assigners to be used as success callbacks when creating entities inline
  const assignCustomer = assignCustomerProvider({
    orderData,
    setOrderData
  });
  const assignMerchant = assignMerchantProvider({ orderData, setOrderData });
  const assignBranch = assignBranchProvider({ orderData, setOrderData });
  const assignPickupLocation = assignPickupLocationProvider({
    orderData,
    setOrderData,
  });
  const assignLocation = assignLocationProvider({ orderData, setOrderData });

  const canModifySensistiveData =
    defaultOrder == undefined ||
    (orderData?.last_pickup_task == undefined &&
      orderData?.last_delivery_task == undefined);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (orderData) {
      setIsLoading(true);
      setResponse(undefined);
      setLoadingMessage('Saving Order...');
      setMessage('');

      let reason = '';
      if (orderData.id !== '') {
        if (
          orderData.id !== '' &&
          orderData.delivery_state !== DeliveryState.CREATED
        ) {
          reason = prompt('Why are you doing this modification?') ?? '';
          if (reason.length === 0) {
            alert(
              'You should specify a reason in order to proceed with this operation.'
            );
            setIsLoading(false);
            setResponse(undefined);
            return;
          }
        }
      }

      const requestData: any = orderData;
      requestData.price = get_price(
        cod,
        requestData.delivery_fee,
        requestData.delivery_fee_covered_by_merchant
      );
      requestData.reason = reason;

      try {
        let response;

        if (defaultOrder === undefined) {
          // create new
          response = await axios.post<OrderType>(
            `${API_ENDPOINT}/api/v1/orders/`,
            requestData,
            config
          );
          onSuccess && onSuccess(response.data);
          const newOrderData = updateDeliveryFee(
            {
              ...emptyOrder,
              merchant: orderData.merchant,
              merchant_location: orderData.merchant_location,
              workflow: orderData.workflow,
              delivery_state: orderData.delivery_state,
            },
            calculateBaseDeliveryFee(orderData)
          );
          setOrderData(newOrderData);
          setCod([]);
          console.log('post response = ', response);
        } else {
          // update existing
          response = await axios.put(
            `${API_ENDPOINT}/api/v1/order/${orderData.id}/`,
            requestData,
            config
          );

          onSuccess && onSuccess(response.data);
        }
        setResponse(response);
        setMessage('Order saved successfully');
      } catch (e: any) {
        if (axios.isAxiosError(e)) {
          console.log('Response from catch block: ', response);
          setResponse(e.response);

          if (e.response !== undefined)
            setMessage('Failed to save order: ' + e.response.statusText);
          else setMessage('Failed to save order');
        } else {
          setMessage('Failed to save order');
        }
        console.log(e);
      }
      setIsLoading(false);
      setLoadingMessage('');
    }
  };

  const shipmentSourceAndDestinationInput = orderData
    ? [
        <Grid
          container
          spacing={2}
          key="customer"
          alignItems="center"
          justifyContent="center"
          sx={{ flexGrow: 1 }}
        >
          <Grid xs={12} md={12}>
            {orderData.merchant == null && (
              <>
                <Alert severity="warning">Please choose merchant first</Alert>
                <br />
              </>
            )}
            {orderData.merchant != null &&
              orderData.customer &&
              orderData.merchant.id != orderData.customer.merchant?.id && (
                <>
                  <Alert severity="warning">
                    Please choose a customer that corresponds to the chosen
                    merchant.
                  </Alert>
                  <br />
                </>
              )}

            {orderData.customer && orderData.customer.id != '' && (
              <>
                <IconButton
                  onClick={() =>
                    setCreatingNewCustomerOpenFor(orderData.customer)
                  }
                >
                  <Edit color="primary" />
                </IconButton>{' '}
                Modify customer data
              </>
            )}

            <AutocompleteWithThrottle
              label={'Customer'}
              key={orderData.merchant?.id}
              onClickAdd={() => setCreatingNewCustomerOpenFor(emptyCustomer)}
              fetch={handleFetchCustomers}
              disabled={!canModifySensistiveData || orderData.merchant == null}
              value={orderData.customer}
              getOptionLabel={showCustomerAutocompleteOption}
              onChange={(e: any, value: CustomerType | null) => {
                assignCustomer(value ?? emptyCustomer);
              }}
            />
          </Grid>
          <Grid xs={12} md={12}>
            <AutocompleteWithThrottle
              label={'Location'}
              fetchAllOnLoad
              disabled={!canModifySensistiveData || orderData.merchant == null}
              value={orderData.customer_location}
              onChange={(e, value) =>
                setOrderData({ ...orderData, customer_location: value })
              }
              fetch={handleFetchCustomerLocation}
              onClickAdd={() => {
                if (orderData.customer == null)
                  alert('Please select customer first');
                else setCreateLocation(true);
              }}
              getOptionLabel={function (option: ILocation): string {
                return `${displayLocation(option)}`;
              }}
            />
          </Grid>
        </Grid>,

        <Grid container spacing={2} key="merchant">
          <Grid xs={12} md={12}>
            <AutocompleteWithThrottle
              label={'Merchant'}
              onClickAdd={() => setCreatingNewMerchantOpen(true)}
              fetch={handleFetchMerchants}
              disabled={!canModifySensistiveData}
              value={orderData.merchant != null ? orderData.merchant : null}
              getOptionLabel={(option: CompactMerchantType) =>
                option.name + ' ' + option.phone_number
              }
              onChange={(e, value) => {
                const merchant = value;
                if (merchant != null) {
                  let shop_location = null;
                  if (merchant.shop_locations.length > 0) {
                    const defaultPickup = merchant.shop_locations.find(
                      (item) => item.is_default
                    );
                    if (defaultPickup) shop_location = defaultPickup;
                    else shop_location = merchant.shop_locations[0];
                  }
                  setOrderData(
                    updateDeliveryFee(
                      {
                        ...orderData,
                        merchant: merchant,
                        merchant_location: shop_location,
                        customer: null,
                        customer_location: null,
                      },
                      merchant.default_delivery_fee
                    )
                  );
                } else {
                  setOrderData(
                    updateDeliveryFee(
                      {
                        ...orderData,
                        merchant: null,
                        merchant_location: null,
                        customer: null,
                        customer_location: null,
                      },
                      []
                    )
                  );
                }
              }}
            />
          </Grid>

          <Grid xs={12} md={12}>
            <AutocompleteWithThrottle
              label={'Location'}
              fetchAllOnLoad
              value={orderData.merchant_location}
              disabled={!canModifySensistiveData}
              onChange={(e, value) =>
                setOrderData({ ...orderData, merchant_location: value })
              }
              fetch={handleFetchPickupLocations}
              onClickAdd={() => {
                if (orderData.merchant == null)
                  alert('Please select merchant first');
                else setCreatePickupLocation(true);
              }}
              getOptionLabel={function (option: ShopLocationType): string {
                return `${option.name}: ${displayLocation(option)}`;
              }}
            />
          </Grid>
        </Grid>,
      ]
    : [];

  useEffect(() => {
    const updateDeliveryChargeDelta = async () => {

      if (defaultOrder && defaultOrder!.customer_location!.area!.id == orderData!.customer_location!.area!.id && defaultOrder.workflow == workflow) {
        applyDeliveryFeeRules(defaultOrder.delivery_fee_rules??[])
        return
      }

      const endpoint = `${API_ENDPOINT}/v1/delta-delivery-fees/?merchant=${orderData!.merchant!.id}&area=${orderData!.customer_location!.area!.id}`;
      try {
        setIsUpdatingDeliveryFees(true);
        const response = await axios.get<IDeliveryChargeRule[]>(
          endpoint,
          config
        );
        const rules = response.data.filter((item) => item.id != undefined);

        rules.forEach((rule) => {
          if (rule.delta_charge)
            rule.delta_charge = new Decimal(rule.delta_charge);
        });

        applyDeliveryFeeRules(rules);
      } catch (e) {
        console.log(e);
        showMessage('Failed to update delivery fee', 'error');
      } finally {
        setIsUpdatingDeliveryFees(false);
      }
    };

    if (
      !orderData ||
      workflow != Workflow.STANDARD ||
      !orderData.merchant ||
      !orderData.customer_location
    ) {
      clearDeliveryFeeRule();
    } else {
      updateDeliveryChargeDelta();
    }
  }, [orderData?.customer_location, orderData?.customer_location?.area, workflow, orderData?.merchant]);

  useEffect(()=>{
    const updateCriticalSurcharge = async () => {
      
      let newCriticalOrderSurcharge: CriticalOrderSurcharge | undefined = undefined

      if (orderData?.merchant && orderData.is_critical) {
        // we should set critical order fee
        if (defaultOrder?.critical_order_surcharge) {
          newCriticalOrderSurcharge = defaultOrder.critical_order_surcharge
        } else {
          const balance = await fetchBalance(orderData?.merchant?.id)
          if (!balance) {
            showMessage("Something went wrong. Refresh and try again.", "error");
          } else {
            newCriticalOrderSurcharge = {
              method: balance.surcharge_method,
              amount: balance.estimated_surcharge
            }
          }
        }
      } 

      setOrderData({
        ...orderData!, 
        critical_order_surcharge: newCriticalOrderSurcharge,
        delivery_fee: add(minus(orderData?.delivery_fee??[], orderData?.critical_order_surcharge?.amount ?? []), newCriticalOrderSurcharge?.amount ?? [])
      })
      
    }

   
    updateCriticalSurcharge()

   
  }, [orderData?.merchant, orderData?.is_critical])

  let appliedRule: IDeliveryChargeRule | undefined = undefined

  if (orderData && orderData.delivery_fee_rules)
    appliedRule = orderData.delivery_fee_rules.find((rule) =>
      deliveryChargeRuleApplies(rule, orderData.customer_location)
    );

  console.log("applied rule = ", appliedRule)

  const extraChargesDisplayList = orderData ? splitExtraCharges(orderData) : [];

  return (
    <>
      <Typography
        variant="h3"
        component="h3"
        sx={{ textAlign: 'center', mt: 3, }}
      >
        {orderData?.id === '' ? 'Create Order' : 'Edit Order'}
      </Typography>

      {
        orderData?.id == '' && <Box sx={{cursor:'pointer', width: "100%", textDecoration: "underline", color: "primary", display: "flex", justifyContent: "center", alignItems: "center", mb: 3 }} onClick={()=>showVideoTutorial("https://www.youtube.com/embed/GO7gm7TBk4g?si=ZL8svuCEgSUlFdoz")}>
            <IconWithText centered> <YouTube color="primary" /> <Typography sx={{color: "primary"}} variant="body1">Learn how to create an order</Typography></IconWithText>
          </Box>
      }

      {!canModifySensistiveData && (
        <Alert severity="warning">
          Some fields are disable because this order is already included in one
          or more pickup and delivery tasks.
          <br />
          <br />
          You might be able to remove the order from associated tasks if they
          are not started yet. Otherwise, please create a new order if
          necessary.
        </Alert>
      )}

      {isLoading ? (
        <>
          {loadingMessage}
          <br />
          <LinearProgress />
        </>
      ) : (
        <>
          {message != '' && (
            <Alert
              severity={
                response && response.status >= 200 && response.status < 300
                  ? 'success'
                  : 'error'
              }
            >
              <>
                {message}

                {response && response.status >= 300 && (
                  <ErrorsFlattenner rawErrors={response.data} />
                )}
              </>
            </Alert>
          )}

          {orderData && (
            <>
              <br></br>
              <FormControl>
                <FormLabel id="demo-radio-buttons-group-label">
                  Workflow
                </FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue={workflow}
                  row
                  name="radio-buttons-group"
                  onChange={(e) => {
                    setWorkflow(e.target.value as Workflow);
                    setOrderData({
                      ...orderData,
                      workflow: e.target.value as Workflow,
                      is_exchange: false,
                    });
                  }}
                >
                  <FormControlLabel
                    disabled={!canModifySensistiveData}
                    value={Workflow.STANDARD}
                    control={<Radio />}
                    label="Standard"
                  />
                  <FormControlLabel
                    disabled={!canModifySensistiveData}
                    value={Workflow.RETURN}
                    control={<Radio />}
                    label="Return"
                  />
                </RadioGroup>
              </FormControl>
              {orderData.workflow === Workflow.RETURN && (
                <>
                  <br />
                  <br />

                  <FormControl fullWidth>
                    <TextField
                      autoComplete="off"
                      label="Return Reason"
                      type="text"
                      variant="outlined"
                      multiline
                      value={orderData.return_reason}
                      rows={2}
                      onChange={(e) =>
                        setOrderData({
                          ...orderData,
                          return_reason: e.target.value,
                        })
                      }
                    />
                  </FormControl>
                </>
              )}
              <br /> <br />
              <Checkbox
                checked={orderData.is_critical}
                onChange={() =>
                  setOrderData({
                    ...orderData,
                    is_critical: !orderData.is_critical,
                  })
                }
              />{' '}
              Critical Order ⚠️
              
              {defaultOrder?.critical_order_surcharge == null && orderData.is_critical && orderData.merchant && <CriticalOrderBalanceDisplay compact={false} balance={balance} loading={loadingBalance} />}

              <br />
              <IconWithText>
                {' '}
                <Checkbox
                  checked={orderData.is_fragile}
                  onChange={() =>
                    setOrderData({
                      ...orderData,
                      is_fragile: !orderData.is_fragile,
                    })
                  }
                />{' '}
                Fragile (قابل للكسر) <GiCrackedGlass size={24} color={color} />
              </IconWithText>
              {orderData.workflow === Workflow.STANDARD && (
                <>
                  <Checkbox
                    checked={orderData.is_exchange}
                    onChange={() =>
                      setOrderData({
                        ...orderData,
                        is_exchange: !orderData.is_exchange,
                      })
                    }
                  />{' '}
                  Require Exchange
                  <br /> <br />
                </>
              )}
              {defaultOrder == undefined && (
                <FormControl fullWidth>
                  <FormLabel id="demo-radio-buttons-group-label">
                    Packages are at
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    row
                    name="radio-buttons-group"
                    onChange={(e) =>
                      setOrderData({
                        ...orderData,
                        delivery_state: e.target.value as DeliveryState,
                      })
                    }
                  >
                    <FormControlLabel
                      checked={
                        orderData.delivery_state === DeliveryState.AT_WAREHOUSE
                      }
                      value={DeliveryState.AT_WAREHOUSE}
                      control={<Radio />}
                      label="Warehouse"
                    />
                    <FormControlLabel
                      checked={
                        orderData.delivery_state === DeliveryState.CREATED
                      }
                      value={DeliveryState.CREATED}
                      control={<Radio />}
                      label="Pickup Location"
                    />
                  </RadioGroup>
                </FormControl>
              )}
              <form onSubmit={handleSubmit}>
                <InputWithLegend
                  label={"Order ID's"}
                  icon={<QrCode2Icon color={'primary'} />}
                >
                  <Grid container spacing={2}>
                    <Grid xs={12} md={6}>
                      <TextField
                        autoComplete="off"
                        label="ID automatically assigned"
                        type="text"
                        variant="outlined"
                        fullWidth
                        required
                        disabled
                        value={orderData.order_id}
                      />
                    </Grid>

                    <Grid xs={12} md={6}>
                      <TextFieldWithScan
                        label="Reference Number"
                        type="text"
                        variant="outlined"
                        fullWidth
                        value={orderData.reference_id}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            e.stopPropagation();
                          }
                        }}
                        act={(value) =>
                          setOrderData({
                            ...orderData,
                            reference_id: value.trim(),
                          })
                        }
                      />
                    </Grid>
                  </Grid>
                </InputWithLegend>

                <br />

                {workflow === Workflow.STANDARD ? (
                  <>
                    <InputWithLegend
                      label={'Ship From'}
                      key="ship-from"
                      icon={<LocalShippingIcon color="primary" />}
                    >
                      {orderData.workflow == Workflow.RETURN &&
                        orderData.customer_location &&
                        !orderData.customer_location.area && (
                          <IncompleteAddressError />
                        )}
                      {orderData.workflow == Workflow.STANDARD &&
                        orderData.merchant_location &&
                        !orderData.merchant_location.area && (
                          <IncompleteAddressError />
                        )}
                      {shipmentSourceAndDestinationInput[1]}
                    </InputWithLegend>

                    <br />

                    {/* Branch Selection Field */}
                    {defaultOrder === undefined && (
                      <>
                        <InputWithLegend
                          label={'Branch'}
                          key="branch"
                          icon={<Work color="primary" />}
                        >
                          <Autocomplete
                            value={orderData.branch}
                            onChange={(_, newValue) => {
                              // Check if user is overriding the recommendation
                              const isOverride = 
                                branchRecommendation?.recommended_branch &&
                                newValue?.id !== branchRecommendation.recommended_branch.id;
                              
                              setUserOverrodeRecommendation(!!isOverride);
                              setOrderData({
                                ...orderData,
                                branch: newValue,
                              });
                            }}
                            options={allBranches}
                            getOptionLabel={(option) => 
                              `${option.name}${option.letter ? ` (${option.letter})` : ''}`
                            }
                            isOptionEqualToValue={(option, value) => 
                              option.id === value.id
                            }
                            loading={isLoadingBranchRecommendation}
                            disabled={allBranches.length === 1}
                            renderInput={(params) => {
                              const selectedIsRecommended = 
                                orderData.branch?.id === branchRecommendation?.recommended_branch?.id;
                              const selectedIsContext = 
                                orderData.branch?.id === branchRecommendation?.context_branch?.id;
                              const onlyOneBranch = allBranches.length === 1;
                              
                              return (
                                <TextField
                                  {...params}
                                  label="Select Branch *"
                                  variant="outlined"
                                  error={!orderData.branch}
                                  helperText={
                                    !orderData.branch 
                                      ? 'Branch is required' 
                                      : onlyOneBranch
                                      ? 'Only one branch available - automatically selected'
                                      : branchRecommendation?.explanation
                                  }
                                  InputProps={{
                                    ...params.InputProps,
                                    startAdornment: (
                                      <>
                                        {orderData.branch && onlyOneBranch && (
                                          <Chip
                                            label="Only Branch"
                                            color="info"
                                            size="small"
                                            sx={{ mr: 1 }}
                                          />
                                        )}
                                        {orderData.branch && !onlyOneBranch && selectedIsRecommended && (
                                          <Chip
                                            label="Recommended"
                                            color="success"
                                            size="small"
                                            sx={{ mr: 1 }}
                                          />
                                        )}
                                        {orderData.branch && !onlyOneBranch && selectedIsContext && !selectedIsRecommended && (
                                          <Chip
                                            label="Your Branch"
                                            color="primary"
                                            size="small"
                                            variant="outlined"
                                            sx={{ mr: 1 }}
                                          />
                                        )}
                                        {params.InputProps.startAdornment}
                                      </>
                                    ),
                                    endAdornment: (
                                      <>
                                        {isLoadingBranchRecommendation ? (
                                          <CircularProgress color="inherit" size={20} />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                      </>
                                    ),
                                  }}
                                />
                              );
                            }}
                            renderOption={(props, option) => {
                              const isRecommended = 
                                branchRecommendation?.recommended_branch?.id === option.id;
                              const isContext = 
                                branchRecommendation?.context_branch?.id === option.id;
                              
                              return (
                                <Box component="li" {...props}>
                                  <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                    <Typography sx={{ flexGrow: 1 }}>
                                      {option.name}
                                      {option.letter && ` (${option.letter})`}
                                    </Typography>
                                    {isRecommended && (
                                      <Chip
                                        label="Recommended"
                                        color="success"
                                        size="small"
                                        sx={{ ml: 1 }}
                                      />
                                    )}
                                    {isContext && !isRecommended && (
                                      <Chip
                                        label="Your Branch"
                                        color="primary"
                                        size="small"
                                        variant="outlined"
                                        sx={{ ml: 1 }}
                                      />
                                    )}
                                  </Box>
                                </Box>
                              );
                            }}
                          />
                          
                          {/* Warning when user selects different branch than recommended */}
                          {userOverrodeRecommendation && 
                           branchRecommendation?.recommended_branch &&
                           orderData.branch?.id !== branchRecommendation.recommended_branch.id && (
                            <Alert 
                              severity="warning" 
                              sx={{ mt: 2 }}
                              action={
                                <Button
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setUserOverrodeRecommendation(false);
                                    setOrderData({
                                      ...orderData,
                                      branch: {
                                        id: branchRecommendation.recommended_branch!.id,
                                        name: branchRecommendation.recommended_branch!.name,
                                        letter: branchRecommendation.recommended_branch!.letter,
                                      } as BranchType,
                                    });
                                  }}
                                >
                                  Use Recommended
                                </Button>
                              }
                            >
                              <Typography variant="body2">
                                <strong>Note:</strong> You selected a different branch than recommended. 
                                The recommended branch is <strong>{branchRecommendation.recommended_branch.name}</strong> 
                                {branchRecommendation.recommended_branch.letter && ` (${branchRecommendation.recommended_branch.letter})`} 
                                {' '}based on the order location.
                              </Typography>
                            </Alert>
                          )}
                          
                          {/* Info message for recommended branch */}
                          {!userOverrodeRecommendation && 
                           branchRecommendation?.recommended_branch &&
                           orderData.branch?.id === branchRecommendation.recommended_branch.id && (
                            <Alert severity="success" sx={{ mt: 2 }}>
                              <Typography variant="body2">
                                {branchRecommendation.explanation}
                              </Typography>
                            </Alert>
                          )}
                        </InputWithLegend>
                        <br />
                      </>
                    )}

                    <InputWithLegend
                      label={'Ship To'}
                      key="ship-to"
                      icon={<LocationOnIcon color="primary" />}
                    >
                      {orderData.workflow == Workflow.STANDARD &&
                        orderData.customer_location &&
                        !orderData.customer_location.area && (
                          <IncompleteAddressError />
                        )}
                      {orderData.workflow == Workflow.RETURN &&
                        orderData.merchant_location &&
                        !orderData.merchant_location.area && (
                          <IncompleteAddressError />
                        )}
                      {shipmentSourceAndDestinationInput[0]}

                      {(orderData.workflow == Workflow.STANDARD && orderData.customer_location && orderData.delivery_fee_rules && appliedRule) && <>
                            <Typography sx={{mt:2}} variant='body1' color='error'> ⚠️ The selected location {new Decimal(appliedRule.delta_charge).isPos() ?  "incurs extra delivery charge" : "benefits from a delivery charge discount"} {` ${appliedRule.delta_charge.toString()} $`}</Typography>
                            {appliedRule.is_deleted ? `[Deleted Rule] ${displayDeliveryRule(appliedRule)}` : <Box sx={{textDecoration: "underline", cursor: "pointer"}} onClick={()=>setExplainDeliveryRule(true)}><b> See why</b></Box>}
                            {
                              explainDeliveryRule  && <DeliveryChargeOverridesDialog onClose={()=>setExplainDeliveryRule(false)} merchant={orderData.merchant! as MerchantType} defaultFocus={appliedRule}/>
                            }
                      </>}
                    </InputWithLegend>
                  </>
                ) : (
                  <>
                    <InputWithLegend
                      label={'Ship From'}
                      key="ship-from"
                      icon={<LocalShippingIcon color="primary" />}
                    >
                      {shipmentSourceAndDestinationInput[0]}
                    </InputWithLegend>

                    <br />

                    {/* Branch Selection Field */}
                    {defaultOrder === undefined && (
                      <>
                        <InputWithLegend
                          label={'Branch'}
                          key="branch"
                          icon={<Work color="primary" />}
                        >
                          <Autocomplete
                            value={orderData.branch}
                            onChange={(_, newValue) => {
                              // Check if user is overriding the recommendation
                              const isOverride = 
                                branchRecommendation?.recommended_branch &&
                                newValue?.id !== branchRecommendation.recommended_branch.id;
                              
                              setUserOverrodeRecommendation(!!isOverride);
                              setOrderData({
                                ...orderData,
                                branch: newValue,
                              });
                            }}
                            options={allBranches}
                            getOptionLabel={(option) => 
                              `${option.name}${option.letter ? ` (${option.letter})` : ''}`
                            }
                            isOptionEqualToValue={(option, value) => 
                              option.id === value.id
                            }
                            loading={isLoadingBranchRecommendation}
                            disabled={allBranches.length === 1}
                            renderInput={(params) => {
                              const selectedIsRecommended = 
                                orderData.branch?.id === branchRecommendation?.recommended_branch?.id;
                              const selectedIsContext = 
                                orderData.branch?.id === branchRecommendation?.context_branch?.id;
                              const onlyOneBranch = allBranches.length === 1;
                              
                              return (
                                <TextField
                                  {...params}
                                  label="Select Branch *"
                                  variant="outlined"
                                  error={!orderData.branch}
                                  helperText={
                                    !orderData.branch 
                                      ? 'Branch is required' 
                                      : onlyOneBranch
                                      ? 'Only one branch available - automatically selected'
                                      : branchRecommendation?.explanation
                                  }
                                  InputProps={{
                                    ...params.InputProps,
                                    startAdornment: (
                                      <>
                                        {orderData.branch && onlyOneBranch && (
                                          <Chip
                                            label="Only Branch"
                                            color="info"
                                            size="small"
                                            sx={{ mr: 1 }}
                                          />
                                        )}
                                        {orderData.branch && !onlyOneBranch && selectedIsRecommended && (
                                          <Chip
                                            label="Recommended"
                                            color="success"
                                            size="small"
                                            sx={{ mr: 1 }}
                                          />
                                        )}
                                        {orderData.branch && !onlyOneBranch && selectedIsContext && !selectedIsRecommended && (
                                          <Chip
                                            label="Your Branch"
                                            color="primary"
                                            size="small"
                                            variant="outlined"
                                            sx={{ mr: 1 }}
                                          />
                                        )}
                                        {params.InputProps.startAdornment}
                                      </>
                                    ),
                                    endAdornment: (
                                      <>
                                        {isLoadingBranchRecommendation ? (
                                          <CircularProgress color="inherit" size={20} />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                      </>
                                    ),
                                  }}
                                />
                              );
                            }}
                            renderOption={(props, option) => {
                              const isRecommended = 
                                branchRecommendation?.recommended_branch?.id === option.id;
                              const isContext = 
                                branchRecommendation?.context_branch?.id === option.id;
                              
                              return (
                                <Box component="li" {...props}>
                                  <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                    <Typography sx={{ flexGrow: 1 }}>
                                      {option.name}
                                      {option.letter && ` (${option.letter})`}
                                    </Typography>
                                    {isRecommended && (
                                      <Chip
                                        label="Recommended"
                                        color="success"
                                        size="small"
                                        sx={{ ml: 1 }}
                                      />
                                    )}
                                    {isContext && !isRecommended && (
                                      <Chip
                                        label="Your Branch"
                                        color="primary"
                                        size="small"
                                        variant="outlined"
                                        sx={{ ml: 1 }}
                                      />
                                    )}
                                  </Box>
                                </Box>
                              );
                            }}
                          />
                          
                          {/* Warning when user selects different branch than recommended */}
                          {userOverrodeRecommendation && 
                           branchRecommendation?.recommended_branch &&
                           orderData.branch?.id !== branchRecommendation.recommended_branch.id && (
                            <Alert 
                              severity="warning" 
                              sx={{ mt: 2 }}
                              action={
                                <Button
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setUserOverrodeRecommendation(false);
                                    setOrderData({
                                      ...orderData,
                                      branch: {
                                        id: branchRecommendation.recommended_branch!.id,
                                        name: branchRecommendation.recommended_branch!.name,
                                        letter: branchRecommendation.recommended_branch!.letter,
                                      } as BranchType,
                                    });
                                  }}
                                >
                                  Use Recommended
                                </Button>
                              }
                            >
                              <Typography variant="body2">
                                <strong>Note:</strong> You selected a different branch than recommended. 
                                The recommended branch is <strong>{branchRecommendation.recommended_branch.name}</strong> 
                                {branchRecommendation.recommended_branch.letter && ` (${branchRecommendation.recommended_branch.letter})`} 
                                {' '}based on the order location.
                              </Typography>
                            </Alert>
                          )}
                          
                          {/* Info message for recommended branch */}
                          {!userOverrodeRecommendation && 
                           branchRecommendation?.recommended_branch &&
                           orderData.branch?.id === branchRecommendation.recommended_branch.id && (
                            <Alert severity="success" sx={{ mt: 2 }}>
                              <Typography variant="body2">
                                {branchRecommendation.explanation}
                              </Typography>
                            </Alert>
                          )}
                        </InputWithLegend>
                        <br />
                      </>
                    )}

                    <InputWithLegend
                      label={'Ship To'}
                      key="ship-to"
                      icon={<LocationOnIcon color="primary" />}
                    >
                      {shipmentSourceAndDestinationInput[1]}
                    </InputWithLegend>
                  </>
                )}
                <br />

                <MoneyInput
                  money={cod}
                  icon={<MonetizationOnIcon color={'primary'} />}
                  setMoney={(m) => setCod(m)}
                  label={
                    orderData.workflow == Workflow.STANDARD
                      ? 'Collect on Delivery'
                      : 'Return COD'
                  }
                />
                <br />
                <MoneyInput
                  money={orderData.pop}
                  icon={<MonetizationOnIcon color={'primary'} />}
                  setMoney={(m) => setOrderData({ ...orderData, pop: m })}
                  label="Pay On Pickup"
                />
                <br />

                {orderData.workflow === Workflow.STANDARD && (
                  <>
                    <MoneyInput
                      footer={
                        (isUpdatingDeliveryFees || loadingBalance) ?<Box justifyContent={"center"} display={"flex"} width={"100%"} mt={1}> <CircularProgress size={20} /> </Box>:
                        calculateExtraDeliveryCharges(orderData).length ==
                        0 ? undefined : (
                          <Alert
                            sx={{ mt: 2, width: '100%' }}
                            severity="warning"
                          >
                            <b>

                              {
                               (isUpdatingDeliveryFees || loadingBalance) ? <CircularProgress size={15} sx={{mr:1}} /> : <>
                              {displayMoney(
                                calculateExtraDeliveryCharges(orderData), true
                              )}</>
                              }
                            </b>

                            <Box
                              sx={{
                                width: '100%',
                                display: 'inline',
                                justifyContent: 'flex-start',
                                mt: 0.5,
                              }}
                            >
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setExtraChargesExpanded(
                                    !extraChargesExpanded
                                  );
                                }}
                                sx={{ p: 0 }}
                              >
                                {extraChargesExpanded ? (
                                  <ExpandLess />
                                ) : (
                                  <ExpandMore />
                                )}
                              </IconButton>
                              <Typography variant="caption" sx={{ ml: 0.5 }}>
                                {extraChargesExpanded ? 'Hide' : 'More Details'}
                              </Typography>
                            </Box>

                            <Collapse in={extraChargesExpanded} sx={{ mt: 1 }}>
                              {(orderData.labels || orderData.delivery_fee_rules || isUpdatingDeliveryFees || loadingBalance || orderData.critical_order_surcharge) && (
                                <GenericTable<{id: string; amount: string, reason: JSX.Element}>
                                  sourceView="labels-create-order-form"
                                  items={extraChargesDisplayList}
                                  selectedItems={new Map()}
                                  getItemUID={(item) => item.id}
                                  columns={[
                                    {
                                      id: 'amount',
                                      header: 'Charge',
                                      display_body: (item) => (
                                        <b>{item.amount}</b>
                                      ),
                                    },
                                    {
                                      id: 'reason',
                                      header: 'Reason',
                                      display_body: (item) => item.reason,
                                    },
                                  ]}
                                  isLoading={(isUpdatingDeliveryFees || loadingBalance)}
                                />
                              )}
                            </Collapse>
                          </Alert>
                        )
                      }
                      money={calculateBaseDeliveryFee(orderData)}
                      icon={<MonetizationOnIcon color={'primary'} />}
                      setMoney={(m) =>
                        setOrderData(updateDeliveryFee(orderData, m))
                      }
                      label="Delivery Fee"
                    />
                  </>
                )}

                <PackagesEditor
                  numberOfPackages={orderData.number_of_packages}
                  setNumberOfPackages={(n) =>
                    setOrderData({ ...orderData, number_of_packages: n })
                  }
                  packagesMetadata={orderData.packages_metadata ?? []}
                  setPackagesMetadata={(meta, number_of_packages) =>
                    setOrderData({
                      ...orderData,
                      packages_metadata: meta,
                      number_of_packages,
                    })
                  }
                  disabled={!canModifySensistiveData}
                />

                <br />

                <FormControl fullWidth>
                  <LabelsInput
                    currentlySelectedLabels={orderData.labels ?? []}
                    setCurrentlySelectedLabels={setSelectedLabels}
                  />
                </FormControl>

                <br />
                <br />
                <FormControl fullWidth>
                  <TextField
                    autoComplete="off"
                    label="Note"
                    type="text"
                    variant="outlined"
                    multiline
                    value={orderData.public_note}
                    rows={2}
                    onChange={(e) =>
                      setOrderData({
                        ...orderData,
                        public_note: e.target.value,
                      })
                    }
                  />
                </FormControl>
                <br />
                <br />
                <FormControl fullWidth>
                  <TextField
                    autoComplete="off"
                    label="Internal Note"
                    type="text"
                    variant="outlined"
                    multiline
                    value={orderData.private_note}
                    rows={2}
                    onChange={(e) =>
                      setOrderData({
                        ...orderData,
                        private_note: e.target.value,
                      })
                    }
                  />
                </FormControl>
                <br />
                <br />
                
                {/* Final warning for branch override - only for new orders */}
                {defaultOrder === undefined &&
                 userOverrodeRecommendation && 
                 branchRecommendation?.recommended_branch &&
                 orderData.branch?.id !== branchRecommendation.recommended_branch.id && (
                  <>
                    <Alert 
                      severity="error" 
                      sx={{ mb: 2 }}
                      icon={<Info />}
                    >
                      <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
                        Warning: Different Branch Selected
                      </Typography>
                      <Typography variant="body2" sx={{ mb: 2 }}>
                        You have selected <strong>{orderData.branch?.name}</strong>
                        {orderData.branch?.letter && ` (${orderData.branch.letter})`}, 
                        but the recommended branch for this order is{' '}
                        <strong>{branchRecommendation.recommended_branch.name}</strong>
                        {branchRecommendation.recommended_branch.letter && 
                          ` (${branchRecommendation.recommended_branch.letter})`}
                        {' '}based on the order location.
                      </Typography>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={confirmedBranchOverride}
                            onChange={(e) => setConfirmedBranchOverride(e.target.checked)}
                            color="error"
                          />
                        }
                        label={
                          <Typography variant="body2">
                            I understand and confirm that I want to proceed with{' '}
                            <strong>{orderData.branch?.name}</strong> instead of the recommended branch.
                          </Typography>
                        }
                      />
                    </Alert>
                  </>
                )}
                
                <Button
                  size={isMobile && !isTablet ? 'small' : 'medium'}
                  type="submit"
                  variant="contained"
                  disabled={
                    isUpdatingDeliveryFees || 
                    loadingBalance ||
                    Boolean(
                      defaultOrder === undefined && 
                      userOverrodeRecommendation && 
                      branchRecommendation?.recommended_branch &&
                      orderData.branch?.id !== branchRecommendation.recommended_branch.id && 
                      !confirmedBranchOverride
                    )
                  }
                >
                  Save Order
                </Button>
              </form>
            </>
          )}
        </>
      )}

      <div>
        {creatingNewCustomerOpenFor && (
          <CustomDialog
            fullWidth
            open={creatingNewCustomerOpenFor != null}
            onClose={() => setCreatingNewCustomerOpenFor(null)}
            fullScreen={isMobile && !isTablet}
            maxWidth="md"
          >
            <div
              style={{
                textAlign: 'right',
                width: '100%',
              }}
            >
              <IconButton onClick={() => setCreatingNewCustomerOpenFor(null)}>
                <ClearIcon color="primary" fontSize="large" />
              </IconButton>
            </div>

            <DialogContent>
              <CreateCustomerForm
                forcedMerchant={orderData?.merchant ?? undefined}
                successCallback={(c) => {
                  assignCustomer(c);
                  console.log("successCallback passed down: ", c);
                  showMessage('Customer Data Updated');
                  setCreatingNewCustomerOpenFor(null);
                }}
                defaultCustomerId={creatingNewCustomerOpenFor.id.toString()}
                allowReuseExisting
              />
            </DialogContent>
          </CustomDialog>
        )}

        <CustomDialog
          fullWidth
          open={creatingNewMerchantOpen}
          onClose={() => setCreatingNewMerchantOpen(false)}
          fullScreen={isMobile && !isTablet}
          maxWidth="md"
        >
          <div
            style={{
              textAlign: 'right',
              width: '100%',
            }}
          >
            <IconButton onClick={() => setCreatingNewMerchantOpen(false)}>
              <ClearIcon color="primary" fontSize="large" />
            </IconButton>
          </div>

          <DialogContent>
            <CreateMerchantForm successCallback={assignMerchant} />
          </DialogContent>
        </CustomDialog>

        <CustomDialog
          fullWidth
          open={createPickupLocation}
          onClose={() => setCreatePickupLocation(false)}
          fullScreen={isMobile && !isTablet}
          maxWidth="md"
        >
          <div
            style={{
              textAlign: 'right',
              width: '100%',
            }}
          >
            <IconButton onClick={() => setCreatePickupLocation(false)}>
              <ClearIcon color="primary" fontSize="large" />
            </IconButton>
          </div>

          <DialogContent>
            <CreatePickupLocationForm
              merchant={orderData?.merchant ?? emptyMerchant}
              successCallback={assignPickupLocation}
            />
          </DialogContent>
        </CustomDialog>

        <CustomDialog
          fullWidth
          open={createLocation}
          onClose={() => setCreateLocation(false)}
          fullScreen={isMobile && !isTablet}
          maxWidth="md"
        >
          <div
            style={{
              textAlign: 'right',
              width: '100%',
            }}
          >
            <IconButton onClick={() => setCreateLocation(false)}>
              <ClearIcon color="primary" fontSize="large" />
            </IconButton>
          </div>

          <DialogContent>
            {orderData?.customer ? (
              <CreateLocationForm
                customer={orderData?.customer}
                successCallback={assignLocation}
              />
            ) : (
              <Alert severity="error">
                Cannot create location for unknown customer.
              </Alert>
            )}
          </DialogContent>
        </CustomDialog>

        <CustomDialog
          fullWidth
          open={creatingNewBranchOpen}
          onClose={() => setCreatingNewBranchOpen(false)}
          fullScreen={isMobile && !isTablet}
          maxWidth="md"
        >
          <div
            style={{
              textAlign: 'right',
              width: '100%',
            }}
          >
            <IconButton onClick={() => setCreatingNewBranchOpen(false)}>
              <ClearIcon color="primary" fontSize="large" />
            </IconButton>
          </div>

          <DialogContent>
            <CreateBranchForm successCallback={assignBranch} />
          </DialogContent>
        </CustomDialog>
      </div>
    </>
  );
}

export default CreateOrderForm;
